var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10237_64989",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4167 26.166C27.4167 26.6263 27.0436 26.9993 26.5833 26.9993H17.3452L19.2559 28.9101C19.5814 29.2355 19.5814 29.7632 19.2559 30.0886C18.9305 30.414 18.4028 30.414 18.0774 30.0886L14.7441 26.7553C14.5876 26.5988 14.4998 26.3866 14.5 26.1653C14.5002 25.9441 14.5883 25.732 14.7451 25.5758L18.0894 22.2425C18.4154 21.9176 18.943 21.9184 19.2679 22.2444C19.5928 22.5704 19.5919 23.098 19.266 23.4229L17.3499 25.3327H26.5833C27.0436 25.3327 27.4167 25.7058 27.4167 26.166Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5 17.8327C29.5 18.0542 29.4118 18.2666 29.2549 18.4229L25.9105 21.7562C25.5846 22.0811 25.0569 22.0803 24.732 21.7543C24.4071 21.4283 24.408 20.9007 24.734 20.5758L26.6501 18.666H17.4167C16.9564 18.666 16.5833 18.2929 16.5833 17.8327C16.5833 17.3724 16.9564 16.9993 17.4167 16.9993L26.6501 16.9993L24.734 15.0896C24.408 14.7647 24.4071 14.237 24.732 13.9111C25.0569 13.5851 25.5846 13.5842 25.9105 13.9091L29.2549 17.2425C29.4118 17.3988 29.5 17.6112 29.5 17.8327Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10237_64989)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 20,
    height: 20,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftRight);
export default __webpack_public_path__ + "static/media/arrow-left-right.56a80ed5f9c28ee0552ef8183d0f1890.svg";
export { ForwardRef as ReactComponent };